export { ArrowDownIcon } from './ArrowDown'
export { ArrowLeftIcon } from './ArrowLeft'
export { ArrowUpIcon } from './ArrowUp'
export { AssignmentIcon } from './Assignment'
export { CheckBigIcon } from './CheckBig'
export { CheckedIcon } from './Checked'
export { CheckedInShield } from './CheckInShield'
export { ChevronDownIcon } from './ChevronDown'
export { ChevronLeftIcon } from './ChevronLeft'
export { ChevronRightIcon } from './ChevronRight'
export { ChevronUpIcon } from './ChevronUp'
export { ClockIcon } from './Clock'
export { ConfirmAddedResource } from './ConfirmAddedResource'
export { CopyIcon } from './Copy'
export { CrossBigIcon } from './CrossBig'
export { CrossIcon } from './Cross'
export { CrossMediumIcon } from './CrossMedium'
export { DocumentIcon } from './Document'
export { DownloadIcon } from './Download'
export { EditIcon } from './Edit'
export { EmailIcon } from './Email'
export { HeartPlusIcon } from './HeartPlus'
export { InfoIcon } from './Info'
export { LinkedinIcon } from './Linkedin'
export { LockIcon } from './Lock'
export { LockOpenIcon } from './LockOpen'
export { NoDemandsAvailable } from './NoDemandsAvailable'
export { PencilIcon } from './Pencil'
export { PlusIcon } from './Plus'
export { PowerBigIcon } from './PowerBig'
export { PowerIcon } from './Power'
export { SubtractIcon } from './Subtract'
export { Sun2Icon } from './Sun2'
export { SunIcon } from './Sun'
export { TrashIcon } from './Trash'
export { TwitterIcon } from './Twitter'
export { UserIcon } from './User'
export { WarningIcon } from './Warning'
export { Water2Icon } from './Water2'
export { WaterIcon } from './Water'
export { Wind2Icon } from './Wind2'
export { WindIcon } from './Wind'

export const getCheckmark = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" fill="none" viewBox="0 0 9 7">
    <path fill="${color}" d="M8.7.3a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4 0l-2-2a1 1 0 0 1 1.4-1.4L3 4.6 7.3.3a1 1 0 0 1 1.4 0Z" />
  </svg>
'`

export const getCheckmark2 = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="${color}">
    <path d="M16.7 5.3c.4.4.4 1 0 1.4l-8 8a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4L8 12.6l7.3-7.3a1 1 0 0 1 1.4 0Z" />
  </svg>
'`

export const getArrowUp = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="${color}">
    <path d="M5.3 9.7a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L11 7.4V15a1 1 0 0 1-2 0V7.4L6.7 9.7a1 1 0 0 1-1.4 0Z" />
  </svg>
'`

export const getArrowDown = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="${color}">
    <path d="M14.7 10.3a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4L9 12.6V5a1 1 0 0 1 2 0v7.6l2.3-2.3a1 1 0 0 1 1.4 0Z" />
  </svg>
'`

export const getChevron = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
    <path stroke="${color}" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m4.5 6.75 4.5 4.5 4.5-4.5" />
  </svg>
'`

export const getThreeLines = (color = '%231fbe4c') => `'
  data:image/svg+xml;utf8,
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" fill="none" viewBox="0 0 9 8">
    <path stroke="${color}" stroke-linecap="round" stroke-width="1.5" d="M4.5.86v6.28M7.64.86v6.28M1.36.86v6.28" />
  </svg>
'`
